import { FACE_KEYS } from '@repo/api-contracts';
import type { EditAreaDraftState } from '../model/edit-area-draft-types';
import { compositeAssetKeys } from './composite-asset';

/**
 * 초안이 쓰는 저장 키 전부 — 색상별 면 사진 키 뒤에 면 합성 에셋(마스크·음영·안내선) 키를 중복 없이 잇는다.
 * 표시 URL 갱신 요청('서버 상태·사진 URL 확인')과 응답 병합(mergePhotoUrls)이 같은 목록을 본다.
 * 최대 30색상 × 4면 + 4면 × 3에셋 = 132 개까지 모이고, 요청은 계약 상한(MAX_FACE_PHOTO_URL_KEYS, 20)씩 나눠 보낸다.
 */
export const draftAssetKeysOf = (state: Pick<EditAreaDraftState, 'draft' | 'faces'>): string[] => [
  ...new Set([
    ...state.draft.colors.flatMap((color) =>
      Object.values(color.faces).map((photo) => photo.photoKey),
    ),
    ...FACE_KEYS.flatMap((face) => {
      const composite = state.faces[face]?.composite;
      return composite ? compositeAssetKeys(composite) : [];
    }),
  ]),
];
